export default {"src":"/_next/static/media/RestfulDeployment.1c488e8e.svg","height":454,"width":684};